import { Colors, Intent } from '@blueprintjs/core'

export function hexToRGBA(hex: string, alpha = 1): string {
  if (!hex || hex.length < 6) return null
  if (hex[0] === '#') return hexToRGBA(hex.substring(1), alpha)

  const extractHex = index => parseInt(`0x${hex.substring(index * 2, index * 2 + 2)}`)
  const red = extractHex(0)
  const green = extractHex(1)
  const blue = extractHex(2)

  if (!(red != null && green != null && blue != null)) return null

  return `rgba(${red},${green},${blue},${alpha})`
}

export function hexForIntent(intent: Intent): string {
  switch (intent) {
    case Intent.SUCCESS:
      return Colors.GREEN3
    case Intent.PRIMARY:
      return Colors.BLUE3
    case Intent.WARNING:
      return Colors.ORANGE2
    case Intent.DANGER:
      return Colors.RED3
    case Intent.NONE:
      return Colors.GRAY3
    default:
      return null
  }
}

export function rgbaForIntent(intent: Intent, alpha = 1) {
  return hexToRGBA(hexForIntent(intent), alpha)
}
